<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
    <button type="button" class="btn active btn-sm" data-toggle="button" aria-pressed="true" (click)="scrollToTop()">
        <i class="fas fa-chevron-up" style="color: white;"></i>
    </button>
</div>